import { Component, inject, input, signal } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";

import { AdaaHelper } from "../../../core/utils";
import { FormActionButtonsComponent, FormCheckboxComponent } from "../../../shared/components";
import { AdaaBoolean, Language } from "../../../shared/constants/enums";
import { MandatoryFields, ParameterCatalog } from "../../../shared/models";
import { SystemLayoutService } from "../../../shared/services";
import { MandatoryApiService } from "../../../shared/services/mandatory-api-service";

@Component({
  selector: "adaa-mandatory-fields-editor",
  imports: [FormActionButtonsComponent, FormCheckboxComponent],
  templateUrl: "./mandatory-fields-editor.html",
  styleUrl: "./mandatory-fields-editor.scss",
})
export class MandatoryFieldsEditorComponent {
  private _mandatoryApiService = inject(MandatoryApiService);
  private _router = inject(Router);
  private _toastrService = inject(ToastrService);
  private _translateService = inject(TranslateService);
  private _systemLayoutService = inject(SystemLayoutService);

  readonly #untilDestroy = AdaaHelper.untilDestroyed();
  AdaaBoolean = AdaaBoolean;
  AdaaHelper = AdaaHelper;
  language = Language;

  searchKey = input.required<string>();
  mandatoryFields = signal<MandatoryFields>({
    name: "",
    nameAE: "",
    nameEN: "",
    searchKey: "",
    mandatory: "",
    type: "",
    parameterCatalogs: [],
  });

  public ngOnInit() {
    this._systemLayoutService.hasActiveEntityChanged$.pipe(this.#untilDestroy()).subscribe({
      next: () => {
        this._router.navigateByUrl(`/console`);
      },
    });
    this._getMandatoryFields();
  }

  private _getMandatoryFields() {
    this._mandatoryApiService.getMandatoryFieldsBySearchKey(this.searchKey()).subscribe({
      next: (res) => {
        if (res.inError) return;
        this.mandatoryFields.set(res.responseData);
      },
    });
  }

  public goBack() {
    this._router.navigateByUrl(`/console/mandatory`);
  }

  public toggleMandatory(value: AdaaBoolean, item: ParameterCatalog) {
    this.mandatoryFields.update((fields) => {
      const updatedParameterCatalogs = fields.parameterCatalogs.map((catalog) => {
        if (catalog.id === item.id) {
          return { ...catalog, mandatory: value };
        }
        return catalog;
      });
      return { ...fields, parameterCatalogs: updatedParameterCatalogs };
    });
  }

  public submit(isFinish = false) {
    this._mandatoryApiService.updateMandatoryFields(isFinish, this.mandatoryFields()).subscribe({
      next: (response) => {
        if (response.inError) return;
        this._toastrService.success(this._translateService.instant("notification.success.save"));
        this.goBack();
      },
    });
  }
}
